/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */

export const GenericUrlErrorTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.GenericUrlError';
export const GenericUrlErrorDiscriminant = 'GENERIC_URL_ERROR';
export const GenericUrlErrorDiscriminantKey = 'type';
export const InvalidFormatTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidFormat';
export const InvalidFormatDiscriminant = 'INVALID_FORMAT';
export const InvalidFormatDiscriminantKey = 'type';
export const InvalidLengthTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidLength';
export const InvalidLengthDiscriminant = 'INVALID_LENGTH';
export const InvalidLengthDiscriminantKey = 'type';
export const InvalidReservationExtensionTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidReservationExtension';
export const InvalidReservationExtensionDiscriminant = 'INVALID_RESERVATION_EXTENSION';
export const InvalidReservationExtensionDiscriminantKey = 'type';
export const MarketplaceUrlsClientErrorDiscriminantKey = 'type';
export const PortalIdMismatchTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.PortalIdMismatch';
export const PortalIdMismatchDiscriminant = 'PORTAL_ID_MISMATCH';
export const PortalIdMismatchDiscriminantKey = 'type';
export const ScreenshotNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.ScreenshotNotFound';
export const ScreenshotNotFoundDiscriminant = 'SCREENSHOT_NOT_FOUND';
export const ScreenshotNotFoundDiscriminantKey = 'type';
export const SiteNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.SiteNotFound';
export const SiteNotFoundDiscriminant = 'SITE_NOT_FOUND';
export const SiteNotFoundDiscriminantKey = 'type';
export const UnexpectedRegexTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UnexpectedRegex';
export const UnexpectedRegexDiscriminant = 'UNEXPECTED_REGEX';
export const UnexpectedRegexDiscriminantKey = 'type';
export const UrlAlreadyRegisteredTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyRegistered';
export const UrlAlreadyRegisteredDiscriminant = 'URL_ALREADY_REGISTERED';
export const UrlAlreadyRegisteredDiscriminantKey = 'type';
export const UrlAlreadyReservedTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyReserved';
export const UrlAlreadyReservedDiscriminant = 'URL_ALREADY_RESERVED';
export const UrlAlreadyReservedDiscriminantKey = 'type';
export const UrlInUseTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlInUse';
export const UrlInUseDiscriminant = 'URL_IN_USE';
export const UrlInUseDiscriminantKey = 'type';
export const UrlNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotFound';
export const UrlNotFoundDiscriminant = 'URL_NOT_FOUND';
export const UrlNotFoundDiscriminantKey = 'type';
export const UrlNotReservedTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotReserved';
export const UrlNotReservedDiscriminant = 'URL_NOT_RESERVED';
export const UrlNotReservedDiscriminantKey = 'type';
export const getScreenshotRpc = {
  serviceName: 'com.hubspot.marketplace.urls.rpc.ScreenshotRpc',
  rpcName: 'getScreenshot',
  auth: 'external',
  fingerprint: 'yMEF2-kjD01cmmMEGroNLwTPIEIL4xPp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};